// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics"; // --- IMPORT ANALYTICS ---

// --- IMPORTANT ---
// Paste the firebaseConfig object you got from the Firebase console here.
const firebaseConfig = {
  apiKey: "AIzaSyCooLBmhkWJtwV7-rK3Za8xWabZ6vpdaAY",
  authDomain: "digital-menu-sie.firebaseapp.com",
  projectId: "digital-menu-sie",
  storageBucket: "digital-menu-sie.firebasestorage.app",
  messagingSenderId: "88164395939",
  appId: "1:88164395939:web:b3be4358c6f8b71f228816",
  measurementId: "G-S8MVEMCP69"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app); // --- INITIALIZE ANALYTICS ---

// Function to request permission and get the token
export const requestForToken = async (restaurantId, restaurantUsername) => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      console.log("Notification permission granted.");
      
      // --- IMPORTANT ---
      // Paste the VAPID key you generated in the Firebase console here.
      const currentToken = await getToken(messaging, {
        vapidKey: "BC-SvWl3z7qkUhDB3tpu82-OvVg0s426vNV8EuC_tAROiYuIyjupSq_k2X7VUmNVGAJj4VPC9gBl_024cre84DE",
      });

      if (currentToken) {
        console.log("FCM Token:", currentToken);
        // Send the token to your server to save it
        await saveTokenToServer(currentToken, restaurantId, restaurantUsername);
      } else {
        console.log("No registration token available. Request permission to generate one.");
      }
      return true;
    } else {
      console.log("Unable to get permission to notify.");
      return false;
    }
  } catch (err) {
    console.log("An error occurred while retrieving token. ", err);
    return false;
  }
};

// --- NEW: Marketing Lead Magnet ---
export const requestMarketingToken = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const currentToken = await getToken(messaging, {
                vapidKey: "BC-SvWl3z7qkUhDB3tpu82-OvVg0s426vNV8EuC_tAROiYuIyjupSq_k2X7VUmNVGAJj4VPC9gBl_024cre84DE",
            });

            if (currentToken) {
                await saveMarketingTokenToServer(currentToken);
                return true;
            }
        }
        return false;
    } catch (err) {
        console.error("Marketing token error:", err);
        return false;
    }
};

// Function to save the token to your backend
const saveTokenToServer = async (token, customerId, restaurantUsername) => {
    try {
        const response = await fetch('https://menu.searchisend.in/apimenu/save-fcm-token.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 
                token: token,
                customerId: customerId,
                restaurantUsername: restaurantUsername
            }),
        });
        const result = await response.json();
        console.log('Server response:', result.message);
    } catch (error) {
        console.error('Error saving token to server:', error);
    }
};

const saveMarketingTokenToServer = async (token) => {
    try {
        await fetch('https://menu.searchisend.in/apimenu/save-marketing-token.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ fcm_token: token }),
        });
    } catch (error) {
        console.error('Error saving marketing token:', error);
    }
};

// Listen for messages when the app is in the foreground
onMessage(messaging, (payload) => {
  console.log("Message received. ", payload);
  // You can customize this to show an in-app notification
  new Notification(payload.notification.title, {
    body: payload.notification.body,
    icon: payload.notification.icon,
  });
});
